import React from "react";
import { withTranslation } from 'react-i18next';
import HandleErrorsMessage from "../../pages/Completion/HandleErrorsMessage";
import handleCondition from "./generateForm/handleConditionOnQuestion";
import { getQuestionRender, initResponse } from "./generateForm/questionRender";
import generateYupObject from "./generateForm/yupObject";
import { FieldGroup, Fieldset } from "../../components/fieldset";
import LoadingSpinner from "../../components/loading/LoadingSpinner";

class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorsAPI: [],
            errors: [],
            form: null,
            formData: {},
            conditionInTheForm: [],
            pressSubmitOnce: false,
            submitOnLoading: false,
            loading: true,
            questionPaybox: false,
            questionPayboxshow: false,
            confirmed: false,
        }
        this.generateYupObject = generateYupObject.bind(this);
        this.getQuestionRender = getQuestionRender.bind(this);
        this.initResponse = initResponse.bind(this);
        this.onDataChange = this.onDataChange.bind(this);
    }

    componentDidMount() {
        this.initForm();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.form !== this.props.form) {
            this.initForm();
        }
        if (prevProps.currentStep !== this.props.currentStep) {
            this.setState({ errorsAPI: [], errors: [], pressSubmitOnce: null, submitOnLoading: false, confirmed: false });
        }
    }

    initForm() {
        this.setState({ loading: true });
        let form = Object.assign([], this.props.form);
        form = form.filter(q => q.fieldType !== "custom input" || q.object === "Logic")
        var formDataLoc = {};
        var conditionInTheForm = [];
        for (var index = 0; index < form.length; index++) {
            var question = form[index];
            if (question) {
                var questionName = question.name
                if (question.conditional && question.conditionalList) {
                    for (var clIndex in question.conditionalList) {
                        var cl = question.conditionalList[clIndex]
                        var name = null
                        if (cl && cl?.block !== "") {
                            // eslint-disable-next-line no-loop-func
                            name = form.find(q => q.id === cl?.block)?.name
                        }
                        for (var sInd in cl?.subs) {
                            var s = cl?.subs[sInd];
                            if (cl) {
                                conditionInTheForm.push({
                                    parent: name ? name : questionName,
                                    question: s,
                                    condition: cl
                                })
                            }
                        }
                    }
                }
                if (question.sub) {
                    var parentG = form?.find(q => q.id === question.sub);
                    if (parentG) {
                        if (parentG.fieldType === "custom input" || parentG.fieldType === "custom variable") {
                            var parentsG = form?.filter(q => parentG.conditionalList?.find(c => c?.block === q.id))
                            for (var pIndex in parentsG) {
                                if (parentsG.conditionalList?.find(c => c?.block === question.id)) {
                                    conditionInTheForm.push({
                                        parent: parentsG[pIndex].name,
                                        question: question.id,
                                        condition: parentsG.conditionalList?.find(c => c?.block === question.id)
                                    })
                                }
                            }
                        } else {
                            if (!conditionInTheForm.find(c => c.parent === parentG.name && c.question === question.id)) {
                                conditionInTheForm.push({
                                    parent: parentG.name,
                                    question: question.id,
                                    condition: {}
                                })
                            }
                        }
                    }

                }

            }
        }
        formDataLoc = this.handleDataChange({}, true)
        if (form && formDataLoc) {
            this.schema = this.generateYupObject(form, formDataLoc, this.props.t);
        }
        this.setState({ conditionInTheForm })
        this.setState({ form: this.props.form }, () => { this.setState({ formData: formDataLoc, loading: false }) });
    }

    stepquestionpayboxshows(form, formData) {
        var isquestionpaybox = false;
        var isquestionpayboxshow = false;
        if (form && form.length) {
            for (var index = 0; index < form.length; index++) {
                var question = form[index];
                if (question) {
                    if (question.fieldType === "custom input" && question.label === "Paybox") {
                        isquestionpaybox = true;
                        if (handleCondition(formData, question, form)) {
                            isquestionpayboxshow = question;
                        }
                    }
                }
            }
        }
        return { isquestionpaybox, isquestionpayboxshow };
    }

    onDataChange(formData, currentQuestion) {
        const that = this;
        if (that.state.conditionInTheForm && that.state.conditionInTheForm.find(c => c.parent === currentQuestion.name || c?.condition?.and?.block === currentQuestion.id)) {
            var form = Object.assign([], that.props.form);
            that.schema = null;
            var locFormData = that.handleDataChange(formData)
            that.schema = that.generateYupObject(form, locFormData, this.props.t);
            that.setState({ formData: locFormData });
        } else {
            this.setState({ formData })
        }
        if (currentQuestion.required && that.state.pressSubmitOnce) {
            that.schema.validate(that.state.formData, { abortEarly: false })
                .catch(function (err) {
                    return err;
                })
                .then(err => { that.setState({ errors: err, formData }) });
        }
    }

    handleDataChange(formData, init = false) {
        var form = Object.assign([], this.props.form);
        form.forEach(q => {
            if (handleCondition(formData, q, this.props.form)) {
                if (q.fieldType === "custom variable") {
                    formData[q.name] = q.value;
                } else if (q.fieldType === "custom input") {
                    if (init && q.object === "Address" && q.options && q.options.length) {
                        q.options.forEach(o => {
                            if (o.value) {
                                var questionAdd = form.find(qAd => qAd.id === o.value);
                                formData[questionAdd.name] = questionAdd.value || "";
                            }
                        })
                    }
                }
            }
        })

        form = form.filter(q => q.fieldType !== "custom variable" && (q.fieldType !== "custom input" || q.object === "Address"))
        if (form && form.length) {
            for (var index = 0; index < form.length; index++) {
                var question = form[index];
                if (handleCondition(formData, question, this.props.form)) {
                    var formDataPart = this.handleQuestionValueChange(formData, question);
                    for (let indexKey = 0; indexKey < Object.keys(formDataPart).length; indexKey++) {
                        var key = Object.keys(formDataPart)[indexKey];
                        formData[key] = formDataPart[key];
                    }
                }

            }
        }
        var { isquestionpaybox, isquestionpayboxshow } = this.stepquestionpayboxshows(this.props.form, formData)
        this.setState({ questionPaybox: isquestionpaybox, questionPayboxshow: isquestionpayboxshow })
        return formData;
    }

    handleQuestionValueChange(formData, question) {
        if (!handleCondition(formData, question, this.props.form) && !(this.props.form.find(q => q.id !== question.id && q.name === question.name && handleCondition(formData, q, this.props.form)))) {
            formData[question.name] = "";
        } else {
            if (!formData[question.name] && formData[question.name] !== "" && formData[question.name] !== 0) {
                var initValue = this.initResponse(question);
                if (initValue !== null) {
                    formData[question.name] = initValue;
                }
            }
        }
        return formData;
    }

    handleSubmitForm() {
        this.props.toTheTop()
        if (!this.state.submitOnLoading) {
            this.setState({ submitOnLoading: true });
            this.setState({ pressSubmitOnce: true });
            this.setState({ errors: null })
            const that = this;
            if (this.props.form.find(f => f.fieldType !== "custom input" && f.fieldType !== "custom variable")) {
                const formData = that.state.formData;
                that.schema.isValid(formData).then(valid => {
                    if (valid) {
                        this.props.handleSubmit(formData).then(res => {
                            if (res) {
                                that.setState({ submitOnLoading: false, pressSubmitOnce: null });
                                that.props.toTheTop()
                            }
                        }).catch(() => {
                            that.props.toTheTop()
                            that.setState({ submitOnLoading: false });
                        });
                    }
                    else {
                        that.schema.validate(formData, { abortEarly: false })
                            .catch(function (err) {
                                return err;
                            })
                            .then(err => {
                                that.setState({ errors: err, submitOnLoading: false })
                            });
                    }
                });
            } else {
                this.props.handleSubmit({}).then(res => {
                    if (res) {
                        that.setState({ submitOnLoading: false, pressSubmitOnce: null });
                        that.props.toTheTop()
                    }
                }).catch(() => {
                    that.props.toTheTop()
                    that.setState({ submitOnLoading: false });
                });
            }
        }
    }

    render() {
        const { t } = this.props;
        const interactiveCustomInputs = ["Stripe", "Paybox", "Address"];
        const isTextOnly = !this.props.form?.some(f =>
            (f.fieldType !== "custom input" && f.fieldType !== "custom variable") ||
            (f.fieldType === "custom input" && interactiveCustomInputs.includes(f.object))
        );
        return (<>{this.state.loading ? <></> :
            <form className="relative">
                <Fieldset className="main" >
                    <HandleErrorsMessage errors={this.state.errorsAPI && this.state.errorsAPI.length > 0 ? this.state.errorsAPI : (this.state.errors?.errors?.length > 0 ? [t("Veuillez corriger les erreurs de votre formulaire avant de soumettre.")] : null)} />
                    <div className="pb-5" key="questionsrender">
                        <FieldGroup>
                            <div className="form-grid grid grid-cols-1 gap-x-5 gap-y-4 md:grid-cols-2">
                                {this.state.form && this.state.form.length ? (
                                    this.state.form.map((question, key) => {
                                        return this.getQuestionRender(question, key);
                                    })
                                ) : null
                                }
                                <div key="submitform mt-7 mb-2" className="md:col-span-2">
                                    {!isTextOnly && (this.props.nextStepBack === false || this.props.pipelineChange) && this.props.next !== false && !(this.state.questionPaybox && this.state.questionPayboxshow && !this.state.questionPayboxshow.value && this.state.questionPayboxshow.options?.find(opt => opt.label === "PBX_TOTAL" && opt.value !== "0")) ?
                                        <label className="flex items-start gap-3 cursor-pointer mb-4 p-3 border  w-full" style={{ borderRadius: '11px', borderColor: this.state.confirmed ? "var(--primary-color)" : "#e7eaef", backgroundColor: "color-mix(in srgb, var(--primary-color) 8%, white)" }}>
                                            <input
                                                type="checkbox"
                                                checked={this.state.confirmed}
                                                onChange={e => this.setState({ confirmed: e.target.checked })}
                                                className="mt-0.5 h-4 w-4 flex-shrink-0 rounded cursor-pointer"
                                                style={{ accentColor: "var(--primary-color)" }}
                                            />
                                            <span className="text-sm text-gray-600 leading-relaxed">
                                                {t("Je certifie l'exactitude des informations fournies et comprends que toute fausse déclaration peut entraîner le rejet de ma candidature.")}
                                            </span>
                                        </label> : null
                                    }
                                    <div className="flex items-center" style={this.props.amountSteps && this.props.amountSteps > this.props.currentStep && this.props.currentStep > 0 && this.props.back ? { justifyContent: "space-between" } : { justifyContent: "flex-end" }}>
                                        {this.props.amountSteps && this.props.amountSteps > this.props.currentStep && this.props.currentStep > 0 && this.props.back ?
                                            <button
                                                type="button"
                                                className="px-5 py-2.5 border text-sm font-medium text-gray-600 hover:border-gray-300 transition-colors bg-white"
                                                style={{ borderRadius: '11px', borderColor: '#e7eaef' }}
                                                onClick={() => {
                                                    this.setState({ errorsAPI: [], pressSubmitOnce: null, submitOnLoading: false });
                                                    this.props.setStep(this.props.currentStep - 1);
                                                }}
                                            >
                                                ← {t("Previous")}
                                            </button>
                                            : null
                                        }
                                        {!(this.state.questionPaybox && this.state.questionPayboxshow && !this.state.questionPayboxshow.value && this.state.questionPayboxshow.options?.find(opt => opt.label === "PBX_TOTAL" && opt.value !== "0")) ?
                                            <div className="flex flex-col items-end gap-2">
                                                <button
                                                    type="button"
                                                    className="px-6 py-2.5 text-white text-sm font-semibold transition-opacity hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed"
                                                    style={{ backgroundColor: "var(--primary-color)", borderRadius: '11px' }}
                                                    disabled={!isTextOnly && (this.props.nextStepBack === false || this.props.pipelineChange) && this.props.next !== false && !this.state.confirmed}
                                                    onClick={() => this.handleSubmitForm()}
                                                >
                                                    {this.props.loading === true ? <LoadingSpinner /> : (this.props.next === null ? t("Finish") : this.props.next === true ? t("Next") : t("Save"))}
                                                </button>
                                                {this.props.next === false &&
                                                    <div className="text-xs text-gray-400 max-w-xs text-center font-bold" style={{ color: "var(--primary-color)" }}>
                                                        {t("Les étapes suivantes ne sont pas accessibles pour le moment, veuillez enregistrer vos informations avant de quitter la page")}
                                                    </div>
                                                }
                                            </div>
                                            : null}
                                    </div>
                                </div>
                            </div>

                        </FieldGroup>
                    </div>

                </Fieldset>
            </form>
        }</>);
    }

}

export default withTranslation()(Form);